import * as React from "react";
const SvgBack = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M14.66 3.2a1 1 0 0 0-1.41-1.4L5.04 10l8.2 8.2a1 1 0 0 0 1.42-1.4L7.86 10z" /></svg>;
export default SvgBack;